import { Route } from "react-router";
import { useToken } from "./useToken";
import { useBiller } from "./useBiller";
import MainRoutes from "../routes/home";
import { useFaq } from "./useFaq";
import ProductRoutes from "../routes/products";
import { onShowLoading } from "../../../shared/ui/Loading/Loading";
import Routes from "../routes";
import { useEffect } from "react";
import { setPartnerCookie } from "./useCookie";
import { useAuth } from "../../../shared/hooks/useAuth";
import { useLoading } from "../../../shared/hooks/useLoading";
import AuthRoutes from "../routes/auth";

const windowUrl = window.location.search;
const params = new URLSearchParams(windowUrl);

export function useMain() {
  const partnerParamsExist = params.get("partner") !== null;
  const tokenParamsExist = params.get("signature") !== null;
  const tokenParams = {
    trxDate: params.get("trxdate"),
    terminalId: params.get("terminalid"),
    token: params.get("token"),
    authCode: params.get("authcode"),
    partnerId: params.get("partnerid"),
    signature: params.get("signature"),
    product: params.get("product"),
  };
  const { setExpired, token } = useAuth();
  const { showLoading } = useLoading();

  const { tokenResponse, isTokenLoading } = useToken(
    tokenParamsExist ? tokenParams : null
  );
  const { billerResponse, isBillerLoading } = useBiller(tokenResponse);
  const { faqResponse } = useFaq(tokenResponse);

  const mainRoutes = Routes.map(({ key, path, component: Component }) => (
    <Route path={path} key={key} element={<Component />} />
  ));

  const authRoutes = AuthRoutes.map(({ key, path, component: Component }) => (
    <Route path={path} key={key} element={<Component />} />
  ));

  const menuBiller = billerResponse?.data;
  const productRoutes =
    !!menuBiller &&
    menuBiller.map((item: { billerId: string; pagesNameInApps: string }) => {
      const product = ProductRoutes.find(
        ({ billerid }) => billerid === item.billerId
      )?.component;
      return (
        <Route
          path={`/${item.pagesNameInApps}`}
          key={`key.${item.pagesNameInApps}`}
          element={<>{product}</>}
        />
      );
    });

  useEffect(() => {
    if (partnerParamsExist) {
      setPartnerCookie(params.get("partner"));
      setExpired(true);
      const win: Window = window;
      win.location.href = window.location.protocol + "//" + window.location.host;
    } else {
      showLoading(true, 750);
    }
  }, [partnerParamsExist]);

  return {
    dataToken: tokenResponse,
    isTokenLoading,
    dataBiller: billerResponse?.data,
    isBillerLoading,
    dataFaq: faqResponse?.faqDesc,
    mainRoutes,
    authRoutes,
    productRoutes,
    pageLoad: onShowLoading(isTokenLoading || isBillerLoading),
    token
  };
}
